import React from 'react';
import { useBinaryState } from '../../../../../hooks/use-binary-state';
import { useModal } from '../../../../../hooks/use-modal';
import { MappingTemplate } from '../../../data/types/mapping-template';
import { ConfirmDeleteMappingModal } from './confirm-delete-mapping-modal';
import { MappingTemplateEditableRow } from './mapping-template-editable-row';
import { MappingTemplateStandardRow } from './mapping-template-standard-row';

export const MappingTemplateRow = ({ importTemplate }) => {
  const [isEdited, startEdit, stopEdit] = useBinaryState();
  const { open, close, isOpen } = useModal();

  if (isEdited) {
    return <MappingTemplateEditableRow importTemplate={importTemplate} onStopEdit={stopEdit} />;
  }

  return (
    <>
      <MappingTemplateStandardRow importTemplate={importTemplate} onStartEdit={startEdit} openModal={open} />
      <ConfirmDeleteMappingModal importTemplate={importTemplate} onClose={close} show={isOpen} />
    </>
  );
};

MappingTemplateRow.propTypes = {
  importTemplate: MappingTemplate.isRequired,
};
